export default "__VITE_ASSET__C2GJ_P8w__"